module.exports = __webpack_public_path__ + "images/assets/7ecdefe98b35a759eb7ce5b35ebd1b65.svg";